module.exports = __webpack_public_path__ + "img/search.4eb099f9.png";